/**
 * BESTIX v5.0 — Guarantee Banner
 * Trust-building banner with guarantees
 */

import { Shield, CheckCircle, Headphones, RefreshCcw } from 'lucide-react';
import { cn } from '@/lib/utils';

interface GuaranteeBannerProps {
  variant?: 'compact' | 'full';
  className?: string;
}

const guarantees = [
  { icon: Shield, title: '100% Guarantee', description: 'Valid tickets or your money back' },
  { icon: CheckCircle, title: 'Verified Authentic', description: 'Every ticket authenticated' },
  { icon: Headphones, title: '24/7 Support', description: 'Concierge help when you need it' },
  { icon: RefreshCcw, title: 'Easy Refunds', description: 'Hassle-free cancellation policy' },
];

export function GuaranteeBanner({ variant = 'full', className }: GuaranteeBannerProps) {
  if (variant === 'compact') {
    return (
      <div className={cn('flex items-center justify-center gap-6 py-3 px-4 bg-[var(--color-navy)] text-white text-sm', className)}>
        {guarantees.slice(0, 3).map((g) => {
          const Icon = g.icon;
          return (
            <div key={g.title} className="flex items-center gap-2">
              <Icon className="w-4 h-4 text-[var(--color-gold)]" />
              <span>{g.title}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className={cn('py-12 px-6 bg-gray-50', className)}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-playfair italic text-2xl text-[var(--color-navy)]">The BESTIX Promise</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {guarantees.map((g) => {
            const Icon = g.icon;
            return (
              <div key={g.title} className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-[var(--color-navy)]/10 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[var(--color-navy)]" />
                </div>
                <h3 className="font-medium text-[var(--color-navy)] mb-1">{g.title}</h3>
                <p className="text-sm text-gray-500">{g.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default GuaranteeBanner;
